import { BigVipFlag } from "./message";

/**
 * 动态的审核状态
 */
export const enum TrendStatus {
  /**
   * 审核中
   */
  PENDING = 0,
  /**
   * 通过
   */
  SUCCESSS = 1,
  /**
   * 不通过
   */
  FAIL = 2,
}

export const enum TrendPrivacy {
  PUBLIC = 1,
  PRIVATE = 2,
}

// 动态类型：1文本2图文3视频
export const enum TrendType {
  TEXT = 1,
  PICTURE = 2,
  VIDEO = 3,
  /**
   * 富文本的文章
   */
  ARTICLE = 4,
}

/**
 * 发布动态的用户身份
 */
export const enum TrendUserIdentity {
  /**
   * 个人
   */
  PERSONAL = "personal",
  /**
   * 公司、机构
   */
  COMPANY = "company",
  /**
   * 机构号
   */
  COMPANY_AUTHED = "company_gp",
}

// 用户违规的类型
export const enum UserDenyStatus {
  NORMAL = 1, // 正常
  FORBIDDEN, // 禁言
  BLOCK, // 拉黑
  FREEZE, // 封号
}

interface TrendTopicItem {
  paramName: string;
  paramId: string;
  /**
   * 表示是否是敏感词
   * 钱鹏给到的解释：面向类型的语言，类型一开始定了key value都是string
   */
  sensi: "true" | "false";
}

export interface TrendItem {
  trendsId: string;
  imId: string;
  userIdentity?: TrendUserIdentity;
  choiceFlag: "0" | "1";
  // 发布者身份标识
  title?: string;
  content: string; // 内容不能为空
  locationAddress?: string; // 定位地址
  longitude?: string; // 经度
  latitude?: string; // 纬度
  province?: string; // 省
  city?: string; // 市
  privacySetting: TrendPrivacy; // 私密设置 1:公开，所有人可见；2:私密，自己可见
  fileIdList?: string[]; // 传从我们这边获取的fileId，不:vodId
  topicList?: string[];
  coverImageFileId: string; // 封面：传从我们这边获取的fileId
  type: TrendType; // 动态类型：1文本2图文3视频
  files?: TrendFileItem[];
  createTime: string;
  imFaceUrl: string; // 头像
  imNickName: string; // 用户名
  likeNum: number;
  viewNum: number; // 阅读量
  commentNum: number;
  collectNum: number;
  topics: TrendTopicItem[] | null;
  auditStatus: TrendStatus;
  coverImageFile: TrendFileItem;
  canAudit?: boolean; // 本人是否可以审核该动态（本人已锁定+该动态未锁定，都是true）
  lockedBy: string; // 被谁锁定，若没有锁定，则为"0"
  lockedTime: string; // 锁定时的时间戳
  lockedUserName: string; // 被锁定人的昵称
  meLocked: "0" | "1"; // 是否被本人锁定，1代表被当前用户锁定了，0代表未被当前用户锁定
  meTransfer: "0" | "1"; // 是否移交给本人的
  auditTags?: string; // 审核时打的标签，是个json string格式
  userStatus?: UserDenyStatus; // 用户的状态
  statusEditLog?: {
    // 当前违规处理人和时间
    createTime: string;
    operatorName: string;
  };
  professionalGuide: "Y" | "N"; // 是否经过个人伯主认证
  boleLevel: string; // 个人伯主等级
  orgId: string; // 机构id
  orgAuth: "Y" | "N"; // 机构是否已认证
  orgName: string; // 机构名称
  orgNickname: string; // 机构简称
  jobList: any[]; // 动态绑定的职位列表
  bindingJobsNum: number; // 动态绑定的职位列表数量
  isUserTop: boolean; // 是否置顶
  verificationStatus: number; // 实名认证状态，1-未认证，2-已认证，3-认证失败，4-待审核
  updateTime: string; // 提交更新时间
  bigVipFlag?: BigVipFlag; // 是否有V标识（0：没有，1：有）
}

export interface TrendFileItem {
  id: string;
  url: string;
  smallUrl: string;
  width: string;
  height: string;
  resourceType: "image" | "video";
}

export interface TrendCommentItem {
  commentsId: string; // 评论id
  appId: string;
  trendsId: string; // 动态id
  trendsUserId: string; // 动态用户id
  userId: string; // 评论用户id
  imId: string;
  imNickName: string; // 昵称
  imFaceUrl: string; // im头像url
  userIdentity: string; // 身份
  content: string; // 评论内容
  ip: string; // 评论发布ip
  ipAddress: string; // ip地址
  province: string; // 省
  city: string; // 市
  district: string; // 区
  likeNum: number; // 点赞量
  replyNum: number; // 回复量
  auditStatus: TrendCommentStatus; // 审核状态 0 待审核 1 通过 2 未通过
  auditTime: string; // 审核通过时间
  createTime: string; // 创建时间
  fileIds?: string;
  files?: CommentFileItem[];
  emojiName?: string;
}

export interface CommentFileItem {
  height: string;
  id: string;
  resourceType: string;
  smallUrl: string;
  url: string;
  width: string;
}
export enum TrendCommentStatus {
  PENDING = 0,
  SUCCESSS = 1,
  FAIL = 2,
}

export enum LikeType {
  TREND = "TRENDS",
  COMMENT = "COMMENTS",
  REPLY = "REPLY",
}

// 关注类型 0 陌生人 1我的关注 2 互关好友 3我的粉丝
export enum FollowType {
  STRANGER = 0,
  FOLLOW,
  FRIEND,
  FANS,
}
